<template>
  <div v-if="isPdf">
    <pdf
      v-for="i in numPages"
      :key="i"
      :src="Weblink"
      :page="i"
      style="display: inline-block; width: 100%"
    ></pdf>
  </div>
  <iframe
    v-else-if="!isPdf"
    :src="Weblink"
    height="100%"
    width="100%"
    frameborder="0"
  ></iframe>
</template>

<script>
const Url = require("url-parse");
import pdf from "vue-pdf";

export default {
  data() {
    return {
      numPages: undefined,
    };
  },
  mounted() {
    const loadingTask = pdf.createLoadingTask(this.Weblink);
    loadingTask.promise.then((pdf) => {
      this.numPages = pdf.numPages;
    });
  },
  props: {
    Weblink: String,
  },
  components: {
    pdf,
  },
  computed: {
    /**
     * Check if url contains a .pdf file,
     * if it does, use gdrive workaround to
     * display them on iOS correctly too
     */
    isPdf() {
      return Url(this.Weblink).pathname.endsWith(".pdf");
    },
  },
};
</script>
